import React, { useRef, useEffect, useState } from 'react';
import { Row, Col, Form, Button, InputGroup, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faEnvelope,
  faFileInvoice,
  faHome,
  faPhone,
  faSpinner,
  faArrowAltCircleUp
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import logoSaleNoti from '../../assets/user/images/logoSaleNoti.png';
import imageAppStore from '../../assets/user/images/appStore.png';
import imageGGPlay from '../../assets/user/images/ggplay.png';
import api from '../../utils/axiosPublic';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons'

function Footer() {
  const formSDT1 = useRef();
  const [posts, setPost] = useState([]);
  const navigate = useNavigate();
  const { productSlug } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    getAllPost();
  }, []);

  const top_up = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  
  const getAllPost = async () => {
    await api
      .get(`/getPostsByTopics/chinh-sach`)
      .then(res => {
        if (res.data.errCode === 0) {
          setPost(res.data.posts[0]?.posts);
        } else {
          toast(res.data.message, { type: 'error' });
        }
      })
      .catch(error => {
        toast(error.message, { type: 'error' });
      });
  };

  const sendSDT = async e => {
    if (formSDT1.current.phone.value.toString().length > 9) {
      const success = await handleSaveCustomer();

      if (success) {
        navigate('/dang-ky-thanh-cong');
        toast(`Đăng ký thành công`, {
          type: 'success',
          autoClose: 1000,
          style: { marginTop: '50px' },
        });
      } 
    } else {
      toast(`Vui lòng nhập số điện thoại`, {
        type: 'error',
        autoClose: 1000,
        style: { marginTop: '50px' },
      });
    }
  };

  const handleSaveCustomer = async () => {
    setIsLoading(true);

    const phone = formSDT1.current.phone.value.toString();

    const data = {
      phone: phone,
      fullName: 'Không',
      slug: productSlug || '',
    };

    try {
      const res = await api.post(`/customer/create`, data);
      setIsLoading(false);

      if (res.data.errCode === 0) {
        formSDT1.current.phone.value = '';
        return true;
      }
    } catch (error) {
      if(error.response.data?.messages?.phone) {
        toast(error.response.data?.messages?.phone, { type: 'error' });
      } else {
      toast(`Có lỗi xảy ra`, {
        type: 'error',
        autoClose: 1000,
        style: { marginTop: '50px' },
      });
      }

      setIsLoading(false);
    }
    return false;
  };

  return (
    <footer className="mt-auto footer_home">
      <Container>
        <Row className="row footer-top clearfix">
          <Col
            lg={{ span: 3, offset: 2 }}
            md={6}
            className="d-flex align-items-center"
          >
            <h5 className="text-dark mb-md-0 ">
              Đăng ký dùng thử miễn phí 7 ngày?
            </h5>
          </Col>

          <Col lg={5} md={6}>
            <Form ref={formSDT1}>
              <InputGroup>
                <Form.Control
                  style={{ borderRadius: '50px', height: '50px' }}
                  placeholder="Nhập số điện thoại..."
                  name="phone"
                />
                <pre> </pre>
                <Button
                  variant="primary"
                  onClick={() => sendSDT()}
                  style={{
                    borderRadius: '50px',
                    height: '50px',
                    marginLeft: '.5rem',
                    padding: '0 1rem',
                  }}
                >
                  {isLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin /> Đang đăng ký...
                    </>
                  ) : (
                    'Đăng ký tư vấn'
                  )}
                </Button>
              </InputGroup>
            </Form>
          </Col>
        </Row>

        <Row className=" footer-link-box clearfix">
          <Col md={4} className="left-f-box">
            <h5 className="fw-bold">CÔNG TY CỔ PHẦN CÔNG NGHỆ KATEC</h5>
            <ul>
              <li>
                <FontAwesomeIcon icon={faHome} /> Địa chỉ: Số 189, đường Phan Huy Chú, phường Tân An, thành phố Cần
                Thơ.
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} /> Số điện thoại:&nbsp;
                <a
                  href="tel: 0889881010"
                  target="_blank"
                  title="Gọi hotline tư vấn."
                >
                  0889.88.1010
                </a>
                &nbsp;-&nbsp;
                <a
                  href="tel: 0847881010"
                  target="_blank"
                  title="Gọi hotline tư vấn."
                >
                  0847.88.1010
                </a>
                &nbsp;-&nbsp;
                <a
                  href="tel: 0847881010"
                  target="_blank"
                  title="Gọi hotline tư vấn."
                >
                  0849.88.1010
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} /> Email: katec.cantho@gmail.com
              </li>
              <li>
                <FontAwesomeIcon icon={faFileInvoice} /> Mã số thuế: 1801633969
              </li>
              <li>
                <FontAwesomeIcon icon={faBuilding} /> Giấy phép kinh doanh: Số
                1801633969 ngày cấp 04/04/2019 thay đổi lần thứ nhất là
                11/01/2022, nơi cấp ở Sở Kế Hoạch và Đầu Tư thành phố Cần Thơ.
              </li>
            </ul>
          </Col>
          <Col md={8}>
            <Row>
              <Col md={6} className="left-f-box">
                <h5 className="fw-bold">HƯỚNG DẪN KHÁCH HÀNG</h5>
                <ul>
                  <li>
                    <Link to={`chinh-sach-app-kafood`}>
                      Chính sách App Kafood
                    </Link>
                  </li>
                  {posts?.map(item => {
                    return (
                      <li>
                        <Link to={`bai-viet/${item.slug}`}>{item.titleVi}</Link>
                      </li>
                    );
                  })}
                </ul>
              </Col>

              <Col md={6} className="left-f-box">
                <h5 className="fw-bold">
                  BẢN ĐỒ CHỈ ĐƯỜNG
                </h5>
                <iframe
                  title="Google map Katec"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.706498664805!2d105.75135877421363!3d10.041060572328492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0886c3ecc3e01%3A0x5a84e770728f1669!2zMTg5IMSQLiBQaGFuIEh1eSBDaMO6LCBQaMaw4budbmcgQW4gS2jDoW5oLCBOaW5oIEtp4buBdSwgQ-G6p24gVGjGoSwgVmnhu4d0IE5hbQ!5e0!3m2!1svi!2s!4v1683166794218!5m2!1svi!2s"
                  width="100%"
                  height="120"
                  style={{ border: '0' }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <div>
                  <a
                    href="http://online.gov.vn/Home/WebDetails/116747"
                    title="Đã đăng ký Bộ công thương - Kafood"
                    className="mt-1"
                  >
                    <img
                      className="image-gov"
                      style={{ width: '200px' }}
                      alt="Đã đăng ký Bộ công thương - Kafood"
                      title="Đã đăng ký Bộ công thương - Kafood"
                      src={logoSaleNoti}
                    />
                  </a>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <center id="download-app">
          <Row className="justify-content-center">
            <Col md={2} xs={6}>
              <a
               
                href="https://apps.apple.com/vn/app/kafood/id6618120465?l=vi"
                target="_blank"
              >
                <img
                  alt="App Store - Kafood"
                  title="App store - Kafood"
                  src={imageAppStore}
                  className="my-1 transform-scale-1-1"
                />
              </a>
            </Col>
            <Col md={2} xs={6}>
              < a
                href="https://play.google.com/store/apps/details?id=com.katec.vn.kakid"
                target="_blank"
              >
                <img
                  alt="App Store - Kafood"
                  title="App store - Kafood"
                  src={imageGGPlay}
                  className="my-1 transform-scale-1-1"
                />
              </a>
            </Col>
          </Row>
        </center>
      </Container>
      <img
        src="../../../assets/user/images/product/detail/footer.png"
        className="icon-small"
        alt=""
      />

      <div className="copyright">
        <p className="text-center">
          Copyright © 2023 Kafood. Một sản phẩm của{' '}
          <a href="https://katec.vn/" target="_blank" >
            {' '}
            Katec.
          </a>
        </p>
      </div>

      <div style={{
          display: 'inline-block', marginTop: '300px',
          position: 'fixed',
          bottom: ' 70px',
          right: '-100px',
          opacity: 0.8,
      }}>
          <a href="tel: 0847881010" className='call-icon' title='Hotline'>
              <div className="wrapper">
                  <div className="ring">
                      <div className="coccoc-alo-phone coccoc-alo-green coccoc-alo-show">
                          <div className="coccoc-alo-ph-circle"></div>
                          <div className="coccoc-alo-ph-circle-fill"></div>
                          <div className="coccoc-alo-ph-img-circle"></div>
                      </div>
                  </div>
              </div>
          </a>

          <br></br>

          <a href="https://www.messenger.com/t/118083051317668" target='_blank' className="mes" title='Nhắn tin FaceBook'>
              <FontAwesomeIcon icon={faFacebookMessenger} size='2xl' style={{
                  height: '40px', width: '40px', marginLeft: '-10px', color: 'blue !important', opacity: 0.9
              }} shake />

              <span></span>
          </a>
          <br></br>
          <div title="Về đầu trang" id="top-up" onClick={top_up}>
              <FontAwesomeIcon icon={faArrowAltCircleUp} size='2xl' style={{ textAlign: 'center', height: '40px', width: '40px', color: 'green', marginLeft: '-50px', }} />
          </div>
      </div>
    </footer>
  );
}

export default Footer;
